// REGISTER
export const P_API_URL = process.env.REACT_APP_INTELLIGENCE_API

export const TWEETS_API = P_API_URL + "/tweets"

export const STATS_API = P_API_URL + "/data-analytics/overview"

export const LOCATION_STATS = P_API_URL + "/data-analytics/location"

export const COMPARISON_API = P_API_URL + "/e-tracker/comparison"

export const ASK_POLICY_AI = P_API_URL + "/ask-policy"

export const ASK_POLICY_AI_STREAM = P_API_URL + "/ask-policy-stream"